

import * as THREE from 'three';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { USDZExporter } from 'three/examples/jsm/exporters/USDZExporter';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { XREstimatedLight } from 'three/examples/jsm/webxr/XREstimatedLight';
import { Pass } from "three/examples153/jsm/postprocessing/Pass.js";
// import { FullScreenQuad } from "three/examples153/jsm/postprocessing/Pass.js";
import { OBB } from 'three/examples/jsm/math/OBB';
import {
    DEFAULT_LAYER,
    GROUND_LAYER, 
    BASE_MODULE_LAYER,
    TOP_MODULE_LAYER,
    ACCESSORY_MODULE_LAYER,
    MODULE_LAYER,
    SNAPPOINT_LAYER,
    DEBUG_LAYER,
    FLOOR_LAYER,
    GRID_SNAP_SIZE,
    SNAP_POINT_RADIUS,
    Y_POSITIVE,
    MAX_CLICK_DURATION
} from 'livom-configurator-definitions'


Shopify.beeclever = Shopify.beeclever || {};
Shopify.beeclever.configurator = Shopify.beeclever.configurator || {};
Shopify.beeclever.configurator.debugMode = Shopify.beeclever.configurator.debugMode || false;

class Tools{
    static correctAngle(radians){
        return Math.round(radians * 1000000) / 1000000
    }

    static applyColor(object, hex){
        object.traverse((o)=>{
            if(o.isMesh){
                o.material.color = new THREE.Color(hex)
            }
        })
    }
    static generateUID() {
        var firstPart = (Math.random() * 46656) | 0;
        var secondPart = (Math.random() * 46656) | 0;
        firstPart = ("000" + firstPart.toString(16)).slice(-3);
        secondPart = ("000" + secondPart.toString(16)).slice(-3);
        return firstPart + secondPart;
    }
    static componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

}

Object.defineProperty(Array.prototype, 'remove', {
    value: function(element) { 
        let index = this.indexOf(element)
        if (index > -1) {
            this.splice(index, 1); 
        }
     },
    enumerable: false
});

navigator.DEVICE_TYPE = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop'
}

navigator.getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return navigator.DEVICE_TYPE.TABLET;
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)){
        return navigator.DEVICE_TYPE.MOBILE;
    }
    return  navigator.DEVICE_TYPE.DESKTOP;
}

class XRSession{

    constructor(container, renderer, scene, object = null){
        this.renderer = renderer
        this.renderer.xr.enabled = true;
        this.scene = scene
        this.object = !!object ? object : scene;
        this.container = container;
        this.session = null;
        this.options = {
            requiredFeatures: [ 'hit-test' ],
            optionalFeatures: [ 'dom-overlay', 'light-estimation' ],
            domOverlay:{
                root: this.container
            }
        }
        this.lighting = new XREstimatedLight( this.renderer );
        this.defaultEnvironment = this.scene.environment
        this.controller = this.renderer.xr.getController( 0 );
		this.scene.add( this.controller );

        this.hitTestSource = null;
        this.hitTestSourceRequested = false;

        //Cursor
        const cursorgeometry =  new THREE.RingGeometry( 0.1, 0.2, 32 );
        cursorgeometry.rotateX(Math.PI/2)
        const cursormaterial = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
        this.cursor = new THREE.Mesh( cursorgeometry, cursormaterial );
        this.cursor.matrixAutoUpdate = false;
        this.cursor.visible = false;
        this.scene.add( this.cursor );

        const that = this;
        this.container.addEventListener('touchstart',function(e){
            if( that.renderer.xr.isPresenting){
                that.touchDown = true;
                that.touchX = e.touches[0].pageX;
                that.touchY = e.touches[0].pageY;
            }
        })

        this.container.addEventListener('touchend',function(e){
            if( that.renderer.xr.isPresenting){
                that.touchDown = false;
            }
        })
        this.container.addEventListener('touchmove',function(e){
            if( that.renderer.xr.isPresenting){
                if(! that.touchDown){
                    return;
                }
                that.deltaX = e.touches[0].pageX -  that.touchX;
                that.deltaY = e.touches[0].pageY -  that.touchY;
                that.touchX = e.touches[0].pageX;
                that.touchY = e.touches[0].pageY;

                if(that.cursor.visible){
                    that.scene.getObjectByName('Configuration').rotation.y += that.deltaX * 0.01;
                }
            }
        })
    }    
    setupLighting(){
        const that = this;
        xrLight.addEventListener( 'estimationstart', () => {

            // Swap the default light out for the estimated one one we start getting some estimated values.
            // scene.add( xrLight );
            // scene.remove( defaultLight );

            // The estimated lighting also provides an environment cubemap, which we can apply here.
            if ( that.lighting.environment ) {
                that.defaultEnvironment = that.scene.environment
                that.scene.environment = that.lighting.environment;
            }

        } );

        xrLight.addEventListener( 'estimationend', () => {

            // Swap the lights back when we stop receiving estimated values.
            //scene.add( defaultLight );
            //scene.remove( xrLight );

            // Revert back to the default environment.
            that.scene.environment = that.defaultEnvironment;

        } );
    }
    //Starts the WebXR Immersive AR session or quicklook
    start(){
        const that = this;
        //WebXR is supported by browser
        const a = document.createElement("a");
        if ( 'xr' in navigator ) {
			navigator.xr.isSessionSupported( 'immersive-ar' ).then(( supported ) => {
				//WebXR is supported by browser
                if (supported) {
                    document.querySelector('[not-in-ar]').classList.add('dont-ar');
					that.startImmersiveAR()
				}
                //immersive-ar is not supported by browser 
				else{
					console.warn('immersive-ar not supported.')
                    if (a.relList.supports("ar")) {
                        that.startARQuickLook()
                    }
                    else{
                        console.warn('AR Quicklook not supported.')
                    }
				}
			} );
		} 
        //WebXR is not supported by browser 
		else{
            console.warn('WebXR not supported.')
            if (a.relList.supports("ar")) {
                that.startARQuickLook()
            }
            else{
                console.warn('AR Quicklook not supported.')
            }
		}
    }
    //Ends the XR session
    end(){
        if(this.session !== null){
            document.querySelector('[not-in-ar]').classList.remove('dont-ar');
            this.session.end();
            this.session = null;
            this.cursor.visible = false;
        }
    }

    render(camera, xrFrame){
        const that = this;
        let referenceSpace = this.renderer.xr.getReferenceSpace();
        if ( that.hitTestSourceRequested === false ) {
            that.session.requestReferenceSpace( 'viewer' ).then( function ( referenceSpace ) {
                that.session.requestHitTestSource( { space: referenceSpace } ).then( function ( source ) {
                    that.hitTestSource = source;
                } );
            } );
            that.hitTestSourceRequested = true;
        }
        if ( that.hitTestSource ) {
            let hitTestResults = xrFrame.getHitTestResults( that.hitTestSource );
            if ( hitTestResults.length ) {
                let hit = hitTestResults[ 0 ];
                that.cursor.matrix.fromArray( hit.getPose( referenceSpace ).transform.matrix );
                that.cursor.visible = true;
            } else {
                that.cursor.visible = false;
            }
        }
        that.renderer.render( that.scene, camera );
    }

    dispose(){
        this.cursor.geometry.dispose()
        this.cursor.material.dispose()
    }
    //Starts the WebXR Immersive AR session
    startImmersiveAR(){
        const that = this;
        window.dispatchEvent(new Event('xr:session:start'))

        navigator.xr.requestSession( 'immersive-ar', that.options ).then(async session => {
            that.renderer.xr.setReferenceSpaceType( 'local' );
            await that.renderer.xr.setSession( session );
            that.session = session

            that.session.addEventListener('end',() => {
                that.hitTestSourceRequested = false;
                that.hitTestSource = null;
                window.dispatchEvent(new Event('xr:session:end'))
                that.container.removeAttribute('xr-session')
            })

            this.container.setAttribute('xr-session', '')
        });
    }

    //Creates USDZ from scene and opens quicklook
    async startARQuickLook(){
        const that = this;

        const onQuickLookAccess = (e) => {
            if (document.visibilityState === "visible") {
                window.dispatchEvent(new Event('xr:session:end'))
                document.removeEventListener("visibilitychange", onQuickLookAccess)
            }
            else{
                window.dispatchEvent(new Event('xr:session:start'))
            }
        }

        document.addEventListener("visibilitychange", onQuickLookAccess)

        this.object.visible = true;
        if(Shopify.beeclever.configurator.debugMode){
            console.log('Converting to USDZ')
        }

        let usdzArrayBuffer = await Promise.race([XRSession.conversionTimeout(5000), new USDZExporter().parse( that.object )])  
        //.catch(error => console.error(error))
        if(Shopify.beeclever.configurator.debugMode){ 
            console.log('Creating Blob from:', usdzArrayBuffer)
        }
        let usdzBlob = new Blob( [ usdzArrayBuffer ], { type: 'application/octet-stream' } );
    
        let link = document.createElement('a')
        link.rel = 'ar'
        link.download = 'model.usdz'
        //required for quicklook to work
        link.appendChild(document.createElement('img'))
        link.href = URL.createObjectURL( usdzBlob );
        if(Shopify.beeclever.configurator.debugMode){
            console.log('Starting AR Quicklook')
        }
        link.click()
        URL.revokeObjectURL(link.href)
    }

    static conversionTimeout(ms) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(null);
            }, ms);
        });
    }

}


// obj - your object (THREE.Object3D or derived)
// point - the point of rotation (THREE.Vector3)
// axis - the axis of rotation (normalized THREE.Vector3)
// theta - radian value of rotation
// function rotateAroundPoint(obj, point, axis, theta){
//     obj.position.sub(point); // remove the offset
//     obj.position.applyAxisAngle(axis, theta); // rotate the POSITION
//     obj.position.add(point); // re-add the offset
//     obj.rotateOnAxis(axis, theta); // rotate the OBJECT
// }

class Measurements{
    constructor(scene, object, camera){
        //Object to add measurements to
        this.object = object;
        //measurements group 
        this.group = new THREE.Group()
        this.group.name = 'Measurements'
        scene.add(this.group)
        this.box = new THREE.Box3();
        //Measuremnt indicators
        this.material = new THREE.LineBasicMaterial({
            color: 0x000000
        });
        this.geometry = new THREE.BufferGeometry()
        this.camera = camera;
        this.lines = new THREE.LineSegments( this.geometry, this.material );
        this.group.add( this.lines );
        this.group.visible = false;
        this.offset = 0.1
        //Measurement labels
        this.labelOffset = 0.3
        this.textX = document.createElement('p')
        this.labelX = new CSS2DObject( this.textX );
        this.group.add(this.labelX)
        this.textY = document.createElement('p')
        this.labelY = new CSS2DObject( this.textY );
        this.group.add(this.labelY)
        this.textZ = document.createElement('p')
        this.labelZ = new CSS2DObject( this.textZ );
        this.group.add(this.labelZ)
    }

    getCenterOffset(){
        let center = new THREE.Vector3()
        this.box.getCenter(center)
        return center
    }

    update(){
        //If measurements object is only child
        // if(this.object.children.length <= 1 ){
        //     return;
        // }

        const that = this;
        this.box = new THREE.Box3();
        //Calculate new box
        that.object.traverse((obj)=>{
            if(!obj.layers.isEnabled(SNAPPOINT_LAYER) && obj.isMesh){
               that.box.expandByObject(obj)
            }
        })
        //make box available from outside the measurement class
        this.object.userData.boundingBox = this.box;

        //if measurements object is not visible don't calculare measurements and indicators
        if(!this.group.visible){
            return;
        }

        //Length to display
        let lenUnit = 'cm'
        //Default values are in m 
        let lenMultiplier = 100;
        let lenAccuracy = 1; //Set the accuracy of the value 1 / lenAccuracy
        this.textX.innerHTML = Math.round((this.box.max.x - this.box.min.x) * lenMultiplier * lenAccuracy ) / lenAccuracy + lenUnit
        this.textY.innerHTML = Math.round((this.box.max.y - this.box.min.y) * lenMultiplier * lenAccuracy ) / lenAccuracy + lenUnit
        this.textZ.innerHTML = Math.round((this.box.max.z - this.box.min.z) * lenMultiplier * lenAccuracy ) / lenAccuracy + lenUnit

        const points = [];
        //Update points based on camera position
        let cameraXSign = this.camera.position.x < 0 ? -1 : 1;
        let cameraZSign = this.camera.position.z < 0 ? -1 : 1;
        this.labelX.position.set(1,1,1)
        //Y - axis
        if(cameraXSign > 0 && cameraZSign < 0){
            points.push( new THREE.Vector3( that.box.min.x - this.offset, that.box.max.y, that.box.min.z - this.offset) );
            points.push( new THREE.Vector3( that.box.min.x - this.offset, that.box.min.y, that.box.min.z - this.offset) );
            this.labelY.position.set(that.box.min.x - this.labelOffset, (that.box.max.y - that.box.min.y)/2, that.box.min.z - this.labelOffset)
        }
        else if(cameraXSign < 0 && cameraZSign < 0){
            points.push( new THREE.Vector3( that.box.max.x + this.offset, that.box.max.y, that.box.min.z - this.offset) );
            points.push( new THREE.Vector3( that.box.max.x + this.offset, that.box.min.y, that.box.min.z - this.offset) );
            this.labelY.position.set(that.box.max.x + this.labelOffset, (that.box.max.y - that.box.min.y)/2, that.box.min.z - this.labelOffset)
        }
        else if(cameraXSign > 0 && cameraZSign > 0){
            points.push( new THREE.Vector3( that.box.min.x - this.offset, that.box.max.y, that.box.max.z + this.offset) );
            points.push( new THREE.Vector3( that.box.min.x - this.offset, that.box.min.y, that.box.max.z + this.offset) );
            this.labelY.position.set(that.box.min.x - this.labelOffset, (that.box.max.y - that.box.min.y)/2, that.box.max.z + this.labelOffset)
        }
        else if(cameraXSign < 0 && cameraZSign > 0){
            points.push( new THREE.Vector3( that.box.max.x + this.offset, that.box.max.y, that.box.max.z + this.offset) );
            points.push( new THREE.Vector3( that.box.max.x + this.offset, that.box.min.y, that.box.max.z + this.offset) );
            this.labelY.position.set(that.box.max.x + this.labelOffset, (that.box.max.y - that.box.min.y)/2, that.box.max.z + this.labelOffset)
        }
        //X & Z - axis
        if(cameraZSign > 0){// z
            points.push( new THREE.Vector3( that.box.min.x /* - this.offset */, that.box.min.y, that.box.max.z + this.offset) );
            points.push( new THREE.Vector3( that.box.max.x /* + this.offset */, that.box.min.y, that.box.max.z + this.offset) );
            this.labelX.position.set(that.box.min.x + (that.box.max.x - that.box.min.x)/2, that.box.min.y, that.box.max.z + this.labelOffset)
        }
        if(cameraZSign < 0){// -z
            points.push( new THREE.Vector3( that.box.max.x /* + this.offset */, that.box.min.y, that.box.min.z - this.offset) );
            points.push( new THREE.Vector3( that.box.min.x /* - this.offset */, that.box.min.y, that.box.min.z - this.offset) );
            this.labelX.position.set(that.box.min.x + (that.box.max.x - that.box.min.x)/2, that.box.min.y, that.box.min.z - this.labelOffset)
        }
        if(cameraXSign > 0){// x
            points.push( new THREE.Vector3( that.box.max.x + this.offset, that.box.min.y, that.box.max.z /* + this.offset */) );
            points.push( new THREE.Vector3( that.box.max.x + this.offset, that.box.min.y, that.box.min.z /* - this.offset */) );
            this.labelZ.position.set(that.box.max.x + this.labelOffset, that.box.min.y, that.box.min.z + (that.box.max.z - that.box.min.z)/2)
        }
        if(cameraXSign < 0){// -x
            points.push( new THREE.Vector3( that.box.min.x - this.offset, that.box.min.y, that.box.min.z /* - this.offset */) );
            points.push( new THREE.Vector3( that.box.min.x - this.offset, that.box.min.y, that.box.max.z /* + this.offset */) );
            this.labelZ.position.set(that.box.min.x - this.labelOffset, that.box.min.y, that.box.min.z + (that.box.max.z - that.box.min.z)/2)
        }
        
        if(!this.group.visible){
            this.hide()
        }

        this.geometry.setFromPoints( points );
    }
    toggle(){
        if(this.group.visible){
            this.hide()
        }
        else{
           this.show()
        }
    }
    hide(){
        this.group.visible = false;
        this.labelX.visible = false;
        this.labelY.visible = false;
        this.labelZ.visible = false;
    }
    show(){
        this.group.visible = true;
        this.labelX.visible = true;
        this.labelY.visible = true;
        this.labelZ.visible = true;
    }
}

class AnimatedAction{
    constructor(callback, duration){
        this.duration = duration;
        this.callback = callback;
        this.done = false;
        this.passedDuration = 0;
        this.progress = 0;
    }
    update(dt){
        this.passedDuration = Math.min(this.duration, this.passedDuration + dt);
        this.progress = this.passedDuration / this.duration;
        if(this.duration > this.passedDuration){
            this.callback(this.progress)
        }
        else{
            this.done = true;
        }
    }
}

class Time{
    constructor(){
        this.lastTime = performance.now(),
        this.currentTime = performance.now(),
        this.deltaTime = 0
    }
    update(){
        this.currentTime = performance.now()
        this.deltaTime = this.currentTime - this.lastTime;
        this.lastTime = this.currentTime;
    }
    static getCurrentTime(){
        return performance.now()
    }
    static getTimeSince(last){
        return performance.now() - last;
    }
    getFPS(){
       return 1000 / this.deltaTime; 
    }
}

class MousePickPass{
    static vert = `
        attribute vec3 mousePickId;

        varying vec3 mpid;

        void main() {
            mpid = mousePickId;
            vec4 modelViewPosition = modelViewMatrix * vec4(position, 1.0);
            gl_Position = projectionMatrix * modelViewPosition; 
        }
    `
    static frag =  `
        varying vec3 mpid;

        void main() {
            gl_FragColor = vec4(mpid,1.0);
        }
    `
    constructor(renderer, camera){
        this.renderer = renderer;
        this.camera = camera;
        this.scene = new THREE.Scene();
        this.renderTarget = new THREE.WebGLRenderTarget( 1,1);
        this.mpidToModule = new Map();
        this.mpoToModule = new Map();
        this.moduleToMpo = new Map();
        this.overrideMaterial =  new THREE.ShaderMaterial({
            uniforms: {},
            fragmentShader: MousePickPass.frag,
            vertexShader: MousePickPass.vert,
            clipping:true,
            side:THREE.DoubleSide
        })
         //this.scene.overrideMaterial = this.overrideMaterial;
    }
    dispose(){
        this.scene.traverse((obj => {
            if(obj.isMesh){
                obj.material.dispose()
                obj.geometry.dispose()
            } 
        })) 
        this.renderTarget.dispose()
    }

    addObject(object){
        const that = this;
        let mpid = Tools.generateUID()
        this.mpidToModule.set(mpid, object)
        object.traverse((node) => {
            if (node.isMesh && !node.layers.isEnabled(SNAPPOINT_LAYER) ) {
                let clone = node.clone()
                clone.layers.mask = object.layers.mask
                this.mpoToModule.set(clone, object)
                this.moduleToMpo.set(object, clone)
                /* additional attribute for mouse picking */
                let mousePickIdAttributeArray = new Float32Array(clone.geometry.attributes.position.count * 3)
                for ( let i = 0; i < mousePickIdAttributeArray.length; i += 3 ) {
                    mousePickIdAttributeArray[ i ] = new THREE.Color('#'+mpid).r
                    mousePickIdAttributeArray[ i+1 ] = new THREE.Color('#'+mpid).g
                    mousePickIdAttributeArray[ i+2 ] = new THREE.Color('#'+mpid).b
                }
                clone.geometry = clone.geometry.clone();
                clone.geometry.setAttribute( 'mousePickId', new THREE.BufferAttribute(mousePickIdAttributeArray, 3, false) )
                clone.material = that.overrideMaterial
                object.mousePickingClones = object.mousePickingClones || new Array()
                object.mousePickingClones.push(clone)
                that.scene.add(clone)
            }
        });
    }
    removeObject(object){
        let mpo = this.moduleToMpo.get(object)
        if(!!mpo)
            mpo.removeFromParent()
    }
    syncObjects(){
        for(const child of this.scene.children){
            child.position.copy(this.mpoToModule.get(child).position)
            child.rotation.copy(this.mpoToModule.get(child).rotation)
        }
    }
    getObjectAt(x,y, layer = MODULE_LAYER){
        this.syncObjects()
        //Save enabled layers
        let layerMask = this.camera.layers.mask
        let viewport = new THREE.Vector4()
        this.renderer.getCurrentViewport(viewport) 
        //this.renderer.setViewport ( 0, 0, this.renderer.domElement.width, this.renderer.domElement.height ) 
        //this.renderer.setScissorTest ( false )
        //Set viewport to cover only the mouse pixel
        this.camera.setViewOffset(
            viewport.z, 
            viewport.w, 
            x * window.devicePixelRatio - viewport.x, 
            y * window.devicePixelRatio - viewport.y, 
            1, 1 );
        //Set Layer --> so the camera matches the layer of the module
        this.camera.layers.set(layer)
        //Set off screen rendertarget
        this.renderer.setRenderTarget( this.renderTarget );
        //render mouse picking scene
        this.renderer.render( this.scene, this.camera);
        //get color from offscreen texture
        let mousePickColor = new Uint8Array(4)
        this.renderer.readRenderTargetPixels(this.renderTarget,0,0,1,1,mousePickColor)
        //get id from color
        let mousePickId = Tools.componentToHex(mousePickColor[0]) + Tools.componentToHex(mousePickColor[1]) + Tools.componentToHex(mousePickColor[2])
        //reset camera to cover whole screen
        this.camera.clearViewOffset();
        //Reset layermask
        this.camera.layers.mask = layerMask
        //reset renderer to use screen 
        this.renderer.setRenderTarget( null );
        //this.renderer.setViewport ( viewport ) 
        //this.renderer.setScissorTest ( true )
        //return selected product
        
        return this.mpidToModule.get(mousePickId)
    }
}

class SnapPoint extends THREE.Object3D{
    //static snapPointGeometry = new THREE.SphereGeometry( SNAP_POINT_RADIUS, 16, 8 );
    //static snapPointMaterial = new THREE.MeshBasicMaterial( { color: 0x00ffff } );
    constructor(id, allowed = new Array(), disable = new Array()){
        //super(SnapPoint.snapPointGeometry, SnapPoint.snapPointMaterial)
        super()
        this.isSnapPoint = true;
        this.module = null
        this.name = id;
        //array of product handles
        this.allowed = allowed;
        this.normal = new THREE.Vector3(-1, 0, 0)
        //which snappoints to disable
        this.disable = disable
        
        if(Shopify.beeclever.configurator.debugMode){
            this.add(new THREE.Mesh(
                new THREE.SphereGeometry(0.075),
                new THREE.MeshStandardMaterial({
                    color: 0xd38856
                })
            ))
            this.children[0].layers.set(SNAPPOINT_LAYER)
        }

        //Contains all snappoints that disable this 
        this.disabled = new Array()
        //sp
        this.snappedTo = null;
        this.layers.set(SNAPPOINT_LAYER)

        this.label = document.createElement( 'p' ); 
        this.label.innerText = id      
        this.labelObject = new CSS2DObject( this.label )
        this.labelObject.layers.set(DEBUG_LAYER)
        this.add(this.labelObject)
    }
    delete(){
        this.label.remove()
        this.labelObject.removeFromParent()
    }
    setNormal(value){
        this.normal.copy(value)
    }
    setModule(module){
        this.module = module;
    }
    snapTo(snapPoint){
        // nearest snappoint that is determined in cursor-tools
        this.snappedTo = snapPoint;
        snapPoint.snappedTo = this;

        //disable linked snappoints
        for(const d of snapPoint.disable){
            // test if snappoint is already disabled or not
            let toDisable = snapPoint.module.getObjectByName(d);
            if (!toDisable.disabled.includes(snapPoint.name)) {
                toDisable.disabled.push(snapPoint.name)
            }
        }
        for(const d of this.disable){
            this.module.getObjectByName(d).disabled.push(this.name)
        }

        if(this.module.layers.isEnabled(BASE_MODULE_LAYER)){

            let ndotn = this.normal.clone().dot(snapPoint.normal.clone())
            ndotn = Math.sign(ndotn) * Math.round(Math.abs(ndotn))

            let newAngle = 0;

            if(ndotn == 1){
                newAngle = Math.PI
            }
            let cross = new THREE.Vector3().crossVectors(this.normal, snapPoint.normal);
            if(ndotn == 0){
                newAngle = cross.y * Math.PI / 2
            }
            
            this.module.rotation.y = newAngle + snapPoint.module.rotation.y;    
        }

        //get world position of snapPoint
        let snapPointWorldPos = new THREE.Vector3();
        snapPoint.getWorldPosition(snapPointWorldPos)

        //move this.module to the snapPoint offset by the position of this snappoint
        this.module.position.copy(snapPointWorldPos.sub(this.position.clone().applyEuler(new THREE.Euler(0,this.module.rotation.y,0))))
        
        if(this.module.layers.isEnabled(TOP_MODULE_LAYER)){
            // this.module.rotation.y = this.normal.angleTo(snapPoint.normal.clone().applyAxisAngle(snapPoint.up ,-snapPoint.rotation.y)) + snapPoint.module.rotation.y 
            //let angle = this.normal.clone().angleTo(snapPoint.normal.clone().applyAxisAngle(snapPoint.up ,-snapPoint.rotation.y)) + snapPoint.module.rotation.y; 
            let ndotn = this.normal.clone().dot(snapPoint.normal.clone())
            ndotn = Math.sign(ndotn) * Math.round(Math.abs(ndotn))

            let newAngle = 0;
            let thisAngle = this.normal.clone().angleTo(snapPoint.normal.clone());
            // console.log("Hey:", thisAngle)
            if(ndotn == 1) {
                // newAngle = thisAngle;
                if(thisAngle > 0.0 && thisAngle < (Math.PI / 8)) {
                    newAngle = thisAngle - (Math.PI / 4);
                }
            }
            if(ndotn == -1){
                newAngle = thisAngle;
                // if thisAngle is between 135 and 180 degrees, then we need to add 45°, so the rotation is correctly applied
                if(newAngle > (0.75 * Math.PI) && newAngle < Math.PI) {
                    newAngle = thisAngle + (Math.PI / 4);
                }
            }
            let cross = new THREE.Vector3().crossVectors(this.normal, snapPoint.normal);
            if(ndotn == 0){
                newAngle = cross.y * thisAngle;
            }
            // let rotAngle = -newAngle + snapPoint.module.rotation.y;
            // console.log("Angelique: ", ndotn, -newAngle, snapPoint.module.rotation.y, rotAngle);
            this.module.rotation.y = -newAngle + snapPoint.module.rotation.y;    

        }

        if(!!this.module.snapPointsTop){
            for(const sp of this.module.snapPointsTop?.children){
                if(sp.isSnapped()){
                    sp.snappedTo.snapTo(sp);
                }
            }
        }
    }
    unsnap(){
        //enable linked snappoints --> after preset
        for(const d of this.snappedTo.disable){
            this.snappedTo.module.getObjectByName(d).disabled.remove(this.snappedTo.name);
        }
        for(const d of this.disable){
            this.module.getObjectByName(d).disabled.remove(this.name);
        }

        //unsnap this from snapped to object
        this.snappedTo.snappedTo = null;
        //remove this snapped to
        this.snappedTo = null;
    }
    isSnapped(){
        return this.snappedTo != null ? true : false;
    }
    isDisabled(){
        return this.disabled.length != 0
    }
    isAvailableFor(module){
        return this.snappedTo === null && (this.allowed.includes(module.handle) || this.allowed.length == 0) && this.disabled.length == 0
    }
    isAllowed(module){
        return (this.allowed.includes(module.handle) || this.allowed.length == 0) && this.disabled.length == 0
    }
}

class LivomModulePreset {

    static MODULE_TYPE = {
        BASE: 'Base',
        TOP: 'Top',
        ACCESSORY: 'Accessory'
    }

    // in config noch die Texturen reinbringen
    constructor(config){
        this.handle = config.handle;
        this.couchTexture = config.couchTexture;
        // this.loadGLTF(config.glb, config.title)
        this.loadCompressed(config.glb, config.title);
        this.snapPoints = config.snapPoints;
        this.variants = config.variants;
        this.title = config.title;
        this.moduleType = config.type;
        this.multiColor = config.multiColor;
        this.orientation = config.angleOrientation;
        this.type_view = config.type_view;
        this.scalevector = config.scalevector;
        this.bbtranslate = config.bbtranslate;
        
    }
    loadGLTF(url, name){
        const that = this;
        new GLTFLoader().load( url , ( gltf ) => {
            that.mesh = gltf.scene;
            that.mesh.name = name
            // computeBoundingBox
            that.boundingBox = new THREE.Box3().setFromObject(that.mesh)
            that.mesh.updateMatrixWorld(true);
            that.boundingBox.applyMatrix4(that.mesh.matrixWorld);

            that.mesh.traverse(o => {
                if(o.isMesh){
                    o.castShadow = true
                    o.receiveShadow = true
                }
            })
            
            window.dispatchEvent(new Event('configurator:module:load'))
        } );
    }
    loadCompressed(url, name){
        const that = this;
        const loader = new GLTFLoader();
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.4.1/');
        loader.setDRACOLoader(dracoLoader);

        loader.load( url , ( gltf ) => {
            that.mesh = gltf.scene;
            that.mesh.name = name

            that.boundingBox = new THREE.Box3().setFromObject(that.mesh)
            that.mesh.updateMatrixWorld(true);
            that.boundingBox.applyMatrix4(that.mesh.matrixWorld);

            that.mesh.traverse(o => {
                if(o.isMesh){
                    o.castShadow = true;
                    o.receiveShadow = true;
                }
            })
            
            window.dispatchEvent(new Event('configurator:module:load'))
        } );
    }
    
   
}

class LivomModuleUI extends CSS2DObject {

    constructor(module){
        let div = document.createElement( 'div' );
        // if(navigator.getDeviceType() === 'mobile'){
        //     div.innerHTML = document.getElementById('LivomModuleUITemplateMobile').innerHTML.replace('{{product.title}}', module.name).trim()
        // }
        // else{
            div.innerHTML = document.getElementById('LivomModuleUITemplate').innerHTML.replace('{{product.title}}', module.name).trim()
        // }
        
        super(div.firstChild)
        this.module = module;
        this.hide()
        this.setupEvents()
    }
    
    show(){
        const that = this;
        this.visible = true;
        setTimeout(()=>{
            if(navigator.getDeviceType() !== 'mobile'){
                that.keepInCanvas()
            }
            that.element.classList.remove('not-visible')
        },10)
        this.update();
    }
    update() {
        const that = this;
        let fabric_mat_link = that.module.currentMaterial;
        // console.log("that: ", that.element);
        that.element.querySelectorAll('#local-selector').forEach(element => {
            let options = null;
            options = element.querySelectorAll('clever-option');
                let glob_mat = null;
                // if length is 0, then it's the first time the update is called
                if(options.length == 0) {
                    let myEl = element.querySelectorAll('option');
                    if(myEl) {
                        myEl.forEach(elementar => {
                            if(elementar.getAttribute('value') == that.module.currentMaterial) {
                                elementar.setAttribute('selected', true);
                            } else {
                                elementar.removeAttribute('selected');
                            }
                        })
                    }

                    glob_mat = document.querySelectorAll('[global-material]');
                    glob_mat.forEach(selected_mat => {
                        if(selected_mat.value === that.module.currentMaterial) {
                            fabric_mat_link = selected_mat.getAttribute('fabric');
                        } 
                    }) 
                } else {
                    options.forEach(option => {
                        if(option.getAttribute('value') === that.module.currentMaterial) {
                            option.setAttribute('selected', true);
                            element.setAttribute('value', that.module.currentMaterial)
                            for (let index = 0; index < option.attributes.length; index++) {
                                const seOp = option.attributes.item(index);
                                element.selectedOption.setAttribute(seOp.name, seOp.value);
                            }
                            element.selectedOption.innerHTML = option.innerHTML;
                            fabric_mat_link = element.selectedOption.getAttribute('fabric');
                        } else {
                            option.removeAttribute('selected');
                        }
                    })  
                }
        })
        that.element.querySelectorAll('#selectedExteriorLocal').forEach(element => {
            element.innerHTML = that.module.currentColorName + '-' + that.module.currentMaterial;
        })     
        // auf dem module sind die aktuellen Informationen für farbe, sowie Material
        // works like this --> really just needs to update
        that.element.querySelectorAll('[color-for-material]').forEach(el => {
            el.removeAttribute('for-current-material')
        })
        //Show color selectors that are usable with the selected material
        that.element.querySelectorAll('[color-for-material="' + that.module.currentMaterial + '"]').forEach(el => {
            el.setAttribute('for-current-material','')
            el.style.backgroundImage = 'url("'+ fabric_mat_link + '")';
        })
    }
    hide(){
        this.visible = false;
        this.element.classList.add('not-visible')
        if(navigator.getDeviceType() !== navigator.DEVICE_TYPE.MOBILE){
            this.element.classList.remove('preventOverlap') 
        }
    }
    keepInCanvas(){
        this.element.style.display = 'block';
        this.element.offsetHeight
        let bcr = this.element.getBoundingClientRect()
        let cbcr = document.querySelector('.ui-canvas').getBoundingClientRect()
        if(bcr.y + bcr.height + bcr.height / 2 > cbcr.y + cbcr.height){
            this.element.classList.add('preventOverlap')
        }
        else{
            this.element.classList.remove('preventOverlap') 
        }
    }
    // Ok hier die rotation aendern auf Math.PI / 4 --> drehen um 45°C
    // sollte dann auch die boundingbox nochmal mit der matrix verrechnet werden?
    setupEvents(){
        const that = this;
        if(that.module.moduleType == LivomModulePreset.MODULE_TYPE.BASE){
            this.element.querySelector('[rotate-left]').addEventListener('click',(e)=>{
                that.module.rotate(Math.PI/2);
                // that.module.mesh.updateMatrixWorld(true);
                // that.module.checkBoundingBox.applyMatrix4(that.module.mesh.matrixWorld);
                // that.module.children[1].applyMatrix4(that.module.mesh.matrixWorld);
            })
            this.element.querySelector('[rotate-right]').addEventListener('click',(e)=>{
                that.module.rotate(-Math.PI/2);
                // that.module.mesh.updateMatrixWorld(true);
                // that.module.checkBoundingBox.applyMatrix4(that.module.mesh.matrixWorld);
                // that.module.children[1].applyMatrix4(that.module.mesh.matrixWorld);
            })
        }
        else{
            this.element.querySelector('[rotate-left]').remove()
            this.element.querySelector('[rotate-right]').remove()
        }
        window.addEventListener('camera:updated', () => {
            that.keepInCanvas()
        })
        this.element.querySelector('[delete]').addEventListener('click',(e)=>{
            that.module.delete()
        })
        that.element.querySelectorAll('[local-color]').forEach(color => {
            color.addEventListener('click', (e) => {
                that.module.currentColorName = color.getAttribute('color-name')
                //if(!!that.module.multiColor){
                    //that.module.changeColor(color.getAttribute('color-code'), Number(color.getAttribute('local-color')))
                    //console.log( Number(color.getAttribute('local-color')))
                //}
                //else{
                    that.module.changeColor(color.getAttribute('color-code'))
                    document.querySelectorAll('#selectedExteriorLocal').forEach(element => {
                        element.innerHTML = that.module.currentColorName + '-' + that.module.currentMaterial;
                    }) 
                //}               
            })
        })
        const closeModuleUI = that.element.querySelectorAll('[close-module-ui]');
        if(closeModuleUI) {
          closeModuleUI.forEach(element => {
            element.addEventListener('click', (event) => {
              event.preventDefault();
              const uiElement = document.querySelectorAll('.livom-module-ui-element');
              uiElement.forEach(uiINsElement => {
                uiINsElement.classList.add('not-visible');
              })
            })
          })
        }
        
        that.element.querySelectorAll('#local-selector').forEach(material => {
            material.addEventListener('change', (e) => {
                that.module.changeMaterial(material.selectedOption.getAttribute('value'))

                that.element.querySelectorAll('[color-for-material]').forEach(el => {
                    el.removeAttribute('for-current-material')
                })
                //Show color selectors that are usable with the selected material
                that.element.querySelectorAll('[color-for-material="' + material.selectedOption.getAttribute('value') + '"]').forEach(el => {
                    el.setAttribute('for-current-material','')
                    el.style.backgroundImage = 'url("'+ material.selectedOption.getAttribute('fabric') + '")'; 
                })
                
                that.module.currentColorName = material.selectedOption.getAttribute('default-name');
                that.module.changeColor(material.selectedOption.getAttribute('default-color'));
                document.querySelectorAll('#selectedExteriorLocal').forEach(element => {
                    element.innerHTML = that.module.currentColorName + '-' + that.module.currentMaterial;
                }) 
            })
        })
    }
    updateColorSwatches(color, index = null){
        const that = this;
        if(!!index){
            that.element.querySelectorAll(`[local-color="${index}"]`).forEach(swatch => {
                if(swatch.getAttribute('color-code') == color){
                    swatch.setAttribute('current','')
                }
                else{
                    swatch.removeAttribute('current')
                }
            })
        }
        else{
            that.element.querySelectorAll(`[local-color]`).forEach(swatch => {
                if(swatch.getAttribute('color-code') == color){
                    swatch.setAttribute('current','');
                    if(swatch.getAttribute('color-for-material') == that.module.currentMaterial) {
                        that.module.currentColorName = swatch.getAttribute('color-name')
                    }
                }
                else{
                    swatch.removeAttribute('current')
                }
            })    
        }
        
    }
    // updateMaterialSelector(color){
    //     const that = this;
    //     that.element.querySelectorAll('#local-selector').forEach(swatch => {
    //         if(swatch.options[swatch.options.selectedIndex].value == color) {
    //             swatch.options[swatch.options.selectedIndex].setAttribute('selected', '');
    //         } else {
    //             swatch.options[swatch.options.selectedIndex].removeAttribute('selected');
    //         }
    //     });
    //     // that.element.querySelectorAll('[local-material]').forEach(swatch => {
    //     //     if(swatch.value == color){
    //     //         // swatch.setAttribute('current','')
    //     //         swatch.setAttribute('selected','')
    //     //     }
    //     //     else{
    //     //         // swatch.removeAttribute('current')
    //     //         swatch.removeAttribute('selected')
    //     //     }
    //     // })
    // }
}

class LivomModule extends THREE.Object3D {

    static presets = new Map()
    static materials = new Map()
    static colorMaterials = new Map()
    static footMaterial = new Map()
    static tabletopMaterial = new Map()

    constructor(handle, serializationId = null, outlinePass = null){
        super();
        const that = this
        let preset = LivomModule.presets.get(handle)
        this.isLivomModule = true;
        this.mesh = preset.mesh.clone()
        this.add(this.mesh)

        this.submeshes = new Array();
        this.mesh.traverse(o => {
            if(o.isMesh && !o.layers.isEnabled(SNAPPOINT_LAYER)){
                //o.material = o.material.clone();
                o.materialName = o.material.name
                this.submeshes.push(o)
                let boxxing = new THREE.Box3().setFromObject(o);
                let smHelper = new THREE.Box3Helper(boxxing, 0x765432)
                o.material.color = new THREE.Color(0xffffff);
                smHelper.layers.set(DEBUG_LAYER)
            }
        })

        this.outline = outlinePass;

        this.serializationId = serializationId || Tools.generateUID()
        this.handle = preset.handle
        this.name = preset.title
        this.multiColor = preset.multiColor
        
        this.currentColor = Shopify.beeclever.configurator.currentColor
        this.currentColorName = Shopify.beeclever.configurator.currentColorName
        this.moduleType = preset.moduleType
        this.variants = preset.variants
        this.scalevector = preset.scalevector
        this.bbtranslate = preset.bbtranslate

        this.boundingBox = preset.boundingBox.clone()
        this.boundingBoxSize = new THREE.Vector3()
        this.boundingBoxCenterOffset = new THREE.Vector3()
        this.boundingBox.getSize(this.boundingBoxSize)
        this.boundingBox.getCenter(this.boundingBoxCenterOffset)
        // change checkboundingbox to OBB!
        this.checkBoundingBox = this.boundingBox.clone();
        // this.checkBoundingBox = new OBB().fromBox3(this.boundingBox);
        if(this.scalevector != null) {
            this.checkBoundingBox.expandByVector(new THREE.Vector3(this.scalevector.x, this.scalevector.y, this.scalevector.z));
            // this.checkBoundingBox.halfSize.multiply(new THREE.Vector3(this.scalevector.x, this.scalevector.y, this.scalevector.z));
            // is needed to move the boundingbox for big nonquadratic modules like mike
            // if makes sense for when the boundingbox of the module should only be scaled
            if(this.bbtranslate != null) {
                this.checkBoundingBox.translate(new THREE.Vector3(this.bbtranslate.x, this.bbtranslate.y, this.bbtranslate.z));
            }
        } else {
            // this.checkBoundingBox.halfSize.multiplyScalar(-0.02);
            this.checkBoundingBox.expandByScalar(-0.02);
        }
        if(Shopify.beeclever.configurator.debugMode) {
            this.add(new THREE.Box3Helper(this.checkBoundingBox))
        }

        this.snapRadius = Math.sqrt(this.boundingBoxSize.x * this.boundingBoxSize.x + this.boundingBoxSize.z * this.boundingBoxSize.z)
        this.visible = false
        
        this.createSnapPoints(preset.snapPoints)
        
        this.layers.enable(MODULE_LAYER);
        if(this.moduleType == LivomModulePreset.MODULE_TYPE.BASE){
            this.layers.enable(BASE_MODULE_LAYER);
            this.rotateRad(preset.orientation * (Math.PI/180.0));
        }
        else if(this.moduleType == LivomModulePreset.MODULE_TYPE.TOP){
            this.layers.enable(TOP_MODULE_LAYER);
        }

        this.ui = new LivomModuleUI(this)
        this.add(this.ui)

        window.addEventListener('configurator:globalcolorchange', (e) => {
            this.currentColorName = Shopify.beeclever.configurator.currentColorName
            that.changeColor(Shopify.beeclever.configurator.currentColor);
            if(that.currentMaterial != Shopify.beeclever.configurator.currentMaterial) {
                that.changeMaterial(Shopify.beeclever.configurator.currentMaterial);
            }
        })

        window.addEventListener('configurator:globalmaterialchange',(e)=>{ 
            that.changeMaterial(Shopify.beeclever.configurator.currentMaterial);
        })
        this.changeMaterial(Shopify.beeclever.configurator.currentMaterial)
        this.changeColor(Shopify.beeclever.configurator.currentColor)
    }

    changeMaterial(material){
        this.currentMaterial = material;
        for(const sm of this.submeshes){
            if(!sm.materialName.includes('M_0_1') && !sm.materialName.includes('M_0_2')){
                sm.material = LivomModule.colorMaterials.get(material + '-' + this.currentColor)
            }
            else if(LivomModule.footMaterial.size != 0 && sm.materialName.includes('M_0_1')) { 
                sm.material = LivomModule.footMaterial.get(this.name.split(' ')[0].toLowerCase());
            } 
            else if(LivomModule.tabletopMaterial.size != 0 && sm.materialName.includes('M_0_2')) {
                sm.material = LivomModule.tabletopMaterial.get(this.name.split(' ')[0].toLowerCase());
            }
        }
        window.dispatchEvent(new Event('configurator:configuration:update'))
    }

    changeColor(color, materialIndex = null){
        if(!!LivomModule.colorMaterials.get(this.currentMaterial + '-' + color)){
            this.ui.updateColorSwatches(color /*, !!materialIndex ? materialIndex : null*/)
            //let materialName = !!materialIndex ? this.multiColor[materialIndex-1] : null
            this.currentColor = color;
            for(const sm of this.submeshes){
                if(!sm.materialName.includes('M_0_1') && !sm.materialName.includes('M_0_2')){
                    //if(materialName === null || (!!materialName && sm.materialName == materialName)){
                        sm.material = LivomModule.colorMaterials.get(this.currentMaterial + '-' + color)
                    //}
                }
                else if(LivomModule.footMaterial.size != 0 && sm.materialName.includes('M_0_1')) {
                    sm.material = LivomModule.footMaterial.get(this.name.split(' ')[0].toLowerCase());
                }            
                else if(LivomModule.tabletopMaterial.size != 0 && sm.materialName.includes('M_0_2')) {
                    sm.material = LivomModule.tabletopMaterial.get(this.name.split(' ')[0].toLowerCase());
                }
            }
            window.dispatchEvent(new Event('configurator:configuration:update'))
        }
    }

    createSnapPoints(config = { base: null, top: null, bottom: null}){
        const that = this;
        function largestComponent(vec){
            let arr = vec.toArray()
            let abs_arr = arr.map(Math.abs)
            let index = abs_arr.indexOf(Math.max(...abs_arr));
            let zero_arr = [0, 0, 0];
            zero_arr[index] = Math.sign(arr[index]);
            return new THREE.Vector3().fromArray(zero_arr)
        }

        //Base Module
        if(this.moduleType == LivomModulePreset.MODULE_TYPE.BASE){
            this.snapPointsBase = new THREE.Group()
            this.snapPointsBase.name = 'SnapPoints'
            this.snapPointsTop = new THREE.Group()
            this.snapPointsTop.name = 'SnapPointsTop'
            if(!!config.base){
                for(const [i,sp] of config.base.entries()){
                    let snapPoint = new SnapPoint(sp.id || 'B'+i, sp.allowed, sp.disable || [])
                    snapPoint.setModule(this)
                    snapPoint.next = sp.next;
                    snapPoint.prev = sp.prev;
                    snapPoint.position.set(Number(sp.x), !!sp.y ? Number(sp.y) : Math.abs(that.boundingBox.max.y - that.boundingBox.min.y) / 2, Number(-sp.z))
                    let n = largestComponent(snapPoint.position)
                    if(!!sp.n){
                        snapPoint.normal.set(sp.n.x || 0, sp.n.y || 0, sp.n.z || 0).normalize ()
                    }
                    else{
                        snapPoint.normal.set( n.x, n.y, -n.z).normalize ()
                    }
                    
                    that.snapPointsBase.add(snapPoint)
                }
            }
            else{
                //Default
                let snapPoint = new SnapPoint('B'+1)
                snapPoint.setModule(this)
                snapPoint.position.set(that.boundingBox.max.x, Math.abs(that.boundingBox.max.y - that.boundingBox.min.y) / 2, 0)
                snapPoint.normal.set(1, 0, 0)
                that.snapPointsBase.add( snapPoint );

                snapPoint = new SnapPoint('B'+2)
                snapPoint.setModule(this)
                snapPoint.position.set(that.boundingBox.min.x, Math.abs(that.boundingBox.max.y - that.boundingBox.min.y) / 2, 0)
                snapPoint.normal.set(-1, 0, 0)
                that.snapPointsBase.add( snapPoint );

                snapPoint = new SnapPoint('B'+3)
                snapPoint.setModule(this)
                snapPoint.position.set(0, Math.abs(that.boundingBox.max.y - that.boundingBox.min.y) / 2, that.boundingBox.max.z)
                snapPoint.normal.set(0, 0, -1)
                that.snapPointsBase.add( snapPoint );

                snapPoint = new SnapPoint('B'+4)
                snapPoint.setModule(this)
                snapPoint.position.set(0, Math.abs(that.boundingBox.max.y - that.boundingBox.min.y) / 2, that.boundingBox.min.z)
                snapPoint.normal.set(0, 0, 1)
                that.snapPointsBase.add( snapPoint );   
            }
            if(!!config.top){
                for(const [i,sp] of config.top.entries()){
                    let snapPoint = new SnapPoint(sp.id || 'T'+i, sp.allow, sp.disable || [])
                    snapPoint.setModule(this)
                    snapPoint.position.set(Number(sp.x), !!sp.y ? Number(sp.y) : Math.abs(that.boundingBox.max.y - that.boundingBox.min.y) / 2, Number(-sp.z))
                    snapPoint.normal.set(Number(sp.n?.x) || 0, Number(sp.n?.y) || 0, Number(sp.n?.z) || 0).normalize ()
                    that.snapPointsTop.add(snapPoint)
                }    
            }
            else{
                //Default
                let snapPoint = new SnapPoint('T'+1)
                snapPoint.setModule(this)
                snapPoint.position.set(0, that.boundingBox.max.y, 0)
                snapPoint.normal.set(1, 0, 0)
                this.snapPointsTop.add( snapPoint );
            }
            this.add(this.snapPointsBase)
            this.add(this.snapPointsTop)
        }
        //Top Module
        else if(this.moduleType == LivomModulePreset.MODULE_TYPE.TOP){
            // this.snapPointsAccessory = new THREE.Group()
            // this.snapPointsAccessory.name = 'SnapPointsAccessory'
            this.snapPointsTop = new THREE.Group()
            this.snapPointsTop.name = 'SnapPointsTop'
            this.snapPointBottom = null;
            if(!!config.bottom){
                const sp = config.bottom;
                let snapPoint = new SnapPoint(sp.id || 'B'+1)
                snapPoint.setModule(this)
                snapPoint.position.set(Number(sp.x) || 0, Number(sp.y) || that.boundingBox.min.y, Number(-sp.z) || 0)
                snapPoint.normal.set(Number(sp.n.x) || 0, Number(sp.n.y) || 0, Number(sp.n.z) || 0).normalize ()
                that.snapPointBottom = snapPoint
            }
            else{
                //Default
                let snapPoint = new SnapPoint('B'+1)
                snapPoint.setModule(this)
                snapPoint.position.set(0, that.boundingBox.min.y, 0)
                snapPoint.normal.set(1, 0, 0)
                that.snapPointBottom = snapPoint
            }
            if(!!config.top){
                for(const [i,sp] of config.top.entries()){
                    let snapPoint = new SnapPoint(sp.id || 'T'+i, sp.allow, sp.disable || [])
                    snapPoint.setModule(this)
                    snapPoint.position.set(Number(sp.x), !!sp.y ? Number(sp.y) : Math.abs(that.boundingBox.max.y - that.boundingBox.min.y) / 2, Number(-sp.z))
                    snapPoint.normal.set(Number(sp.n?.x) || 0, Number(sp.n?.y) || 0, Number(sp.n?.z) || 0).normalize ()
                    that.snapPointsTop.add(snapPoint)
                }    
            }
            else{
                //Default
                let snapPoint = new SnapPoint('T'+1)
                snapPoint.setModule(this)
                snapPoint.position.set(0, that.boundingBox.max.y, 0)
                snapPoint.normal.set(1, 0, 0)
                this.snapPointsTop.add( snapPoint );
            }
            // this.add(this.snapPointsAccessory)
            this.add(this.snapPointsTop)
            this.add(this.snapPointBottom)
        }
    }
    
    // cursor tools remove object seems to be true still
    delete(){
        if(!!this.mousePickingClones){
            for(const c of this.mousePickingClones){
                c.removeFromParent()
            }
        }
            
        //clear all snapped modules
        if(!!this.snapPointsBase){
            for(const sp of this.snapPointsBase?.children){
                if(sp.isSnapped()){
                    sp.unsnap()            
                }
                sp.delete()
            }
        }
        if(!!this.snapPointsTop){
            for(const sp of this.snapPointsTop?.children){
                if(sp.isSnapped()){
                    sp.snappedTo.module.delete()
                }
                sp.delete()
            }
        }
        if(!!this.snapPointsAccessory){
            for(const sp of this.snapPointsAccessory?.children){
                if(sp.isSnapped()){
                    sp.snappedTo.module.delete()
                }
                sp.delete()
            }
        }
        if(!!this.snapPointBottom){
            if(this.snapPointBottom.isSnapped()){
                this.snapPointBottom.unsnap()
            }
            this.snapPointBottom.delete()
        }
        //clear children
        super.clear()
        //removes it from scene
        this.removeFromParent()
        window.dispatchEvent(new Event('configurator:configuration:update'))
    }
    
    rotateRad(radians){
        // that/this is the currently selected module normally the basemodule because this is the element that can be rotated
        // sp is snappoint fo the model to be rotated (normally the base modules) 
        const that = this;
        that.rotation.y += Tools.correctAngle(radians)
        // TODO: Make sure 360° will be 0° again but that's for latter
        that.rotation.y = that.rotation.y % (Math.PI * 2)
        if(!!that.snapPointsTop){
            for(const sp of that.snapPointsTop?.children){
                if(sp.isSnapped()){
                    sp.snappedTo.snapTo(sp);
                }
            }
        }
        
    }
    
    rotate(radians){
        if(this.usedBaseSnapPoints.length == 0){
            this.rotateRad(radians)    
        }
        else if(this.usedBaseSnapPoints.length == 1){
            //Snap to next snapPoint
            let current = this.snapPointsBase.children.find(sp => sp.isSnapped())
            let target = current.snappedTo
            
            if(radians < 0){
                //rotate right
                let prev = LivomModule.prevSnapPoint(current, current, target, this.snapPointsBase.children)// this.snapPointsBase.children.find(sp => sp.name == current.prev)
                current.unsnap()
                prev.snapTo(target)
            }
            else{
                //rotate left
                let next = LivomModule.nextSnapPoint(current, current, target, this.snapPointsBase.children)//this.snapPointsBase.children.find(sp => sp.name == current.next)
                current.unsnap()
                next.snapTo(target)
            }
        }
    }

    static prevSnapPoint(initial, current, target, list){
        let prev = list.find(sp => sp.name == current.prev)
        if(!!prev && prev.isAllowed(target.module)){
            return prev;
        }
        else if(prev == initial){
            return current;
        }
        else{
            return LivomModule.prevSnapPoint(initial, prev, target, list)
        }
    }
    static nextSnapPoint(initial, current, target, list){
        let next = list.find(sp => sp.name == current.next)
        if(!!next && next.isAllowed(target.module)){
            return next;
        }
        else if(next == initial){
            return current;
        }
        else{
            return LivomModule.nextSnapPoint(initial, next, target, list)
        }
    }
    
    hasAvailableSnapPointBase(){
        let hasAvailableSnapPoint = new Array()
        if(!!this.snapPointsBase){
            for(const sp of this.snapPointsBase?.children){
                hasAvailableSnapPoint.push(sp.isSnapped() || sp.isDisabled() )   
            }
            return hasAvailableSnapPoint.includes(false)
        }
        else{
            return false;
        }
    }

    isLocked(){
        this.usedBaseSnapPoints = new Array()
        if(!!this.snapPointsBase){
            for(const sp of this.snapPointsBase?.children){
                if(sp.isSnapped())
                    this.usedBaseSnapPoints.push(sp)   
            }
            return this.usedBaseSnapPoints.length >= 2
        }
        else{
            return false;
        }
    }

    serialize(){
        let s = {
            handle: this.handle, 
            color: this.currentColor,
            material: this.currentMaterial
        }
        if(this.moduleType == LivomModulePreset.MODULE_TYPE.BASE){
            s.position = this.position,
            s.rotation = this.rotation
            s.id = this.serializationId
        }
        if(!!this.snapPointsBase){
            for(const sp of this.snapPointsBase?.children){
                if(sp.isSnapped()){
                    s.base = s.base || {}
                    s.base[sp.name] = {
                        name: sp.snappedTo.name,
                        id: sp.snappedTo.module.serializationId
                    }
                }
            }
        }
        if(!!this.snapPointsTop){
            for(const sp of this.snapPointsTop?.children){
                if(sp.isSnapped()){
                    s.top = s.top || {}
                    s.top[sp.name] = sp.snappedTo.module.serialize()
                }
            }
        }

        return s
    }

}

class CanvasTools{

    static resizeImage(image, width){
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        let aspectRatio = image.height / image.width
        canvas.width = width;
        canvas.height = width * aspectRatio;

        context.drawImage(
            image,
            0,
            0,
            width,
            width * aspectRatio
        );
        return canvas.toDataURL();
    } 

    static async takeScreenshot(canvas){
        const img = new Image();
        img.src = canvas.toDataURL();
        return await new Promise((resolve, reject) => {
            img.onload = function () {
                resolve(img)
            }
            img.onerror = reject
        })
    }
    static downloadScreenshot(canvas, filename = "screenshot.png"){
        var link = document.createElement('a');
        link.href = canvas.toDataURL();
        link.download = filename;
        //To work on firefox
        document.body.appendChild(link)
        link.click();
        link.remove()
    }
}

class ShopifyTools{
    static addToCart(items, product_line){
        fetch('/cart/add.js', {
                body: JSON.stringify({items: items, line: product_line}),
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
                method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                    return response.json();
                }   
            }).then(function(product) {
                document.dispatchEvent(new Event('cart:build')) ;
            }).then(function() {
                window.location.href = "/cart";
            }).catch(function(err) {
                console.error(err);
            }
        );
    }
    static formatMoney(cents){
        let value;
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let money_format = Shopify.moneyFormat;
        switch(money_format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'", ".");
                break;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = (typeof precision != 'undefined' ? precision : 2);
            thousands = (typeof thousands != 'undefined' ? thousands : ".");
            decimal   = (typeof decimal != 'undefined' ? decimal : ",");

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.');
            let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            let cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }
        return money_format.replace(placeholderRegex, value)
    }
}

/*
  This class computes "surface IDs" for a given mesh.

  A "surface" is defined as a set of triangles that share vertices.
  
  Inspired by Ian MacLarty, see:
    https://twitter.com/ianmaclarty/status/1499494878908403712
  Copied from https://github.com/OmarShehata/webgl-outlines/blob/main/threejs-outlines-minimal/src/FindSurfaces.js
  --> why reinvent the wheal a second time
*/
class FindSurfaces {
    constructor() {
        // This identifier, must be globally unique for each surface
        // across all geometry rendered on screen
        this.surfaceId = 0;
      }
    
      /*
       * Returns the surface Ids as a Float32Array that can be inserted as a vertex attribute
       */
      getSurfaceIdAttribute(mesh) {
        const bufferGeometry = mesh.geometry;
        const numVertices = bufferGeometry.attributes.position.count;
        const vertexIdToSurfaceId = this._generateSurfaceIds(mesh);
    
        const colors = [];
        for (let i = 0; i < numVertices; i++) {
          const vertexId = i;
          let surfaceId = vertexIdToSurfaceId[vertexId];
    
          colors.push(surfaceId, 0, 0, 1);
        }
    
        const colorsTypedArray = new Float32Array(colors);
        return colorsTypedArray;
      }
    
      /*
       * Returns a `vertexIdToSurfaceId` map
       * given a vertex, returns the surfaceId
       */
      _generateSurfaceIds(mesh) {
        const bufferGeometry = mesh.geometry;
        const numVertices = bufferGeometry.attributes.position.count;
        const numIndices = bufferGeometry.index.count;
        const indexBuffer = bufferGeometry.index.array;
        const vertexBuffer = bufferGeometry.attributes.position.array;
        // For each vertex, search all its neighbors
        const vertexMap = {};
        for (let i = 0; i < numIndices; i += 3) {
          const i1 = indexBuffer[i + 0];
          const i2 = indexBuffer[i + 1];
          const i3 = indexBuffer[i + 2];
    
          add(i1, i2);
          add(i1, i3);
          add(i2, i3);
        }
        function add(a, b) {
          if (vertexMap[a] == undefined) vertexMap[a] = [];
          if (vertexMap[b] == undefined) vertexMap[b] = [];
    
          if (vertexMap[a].indexOf(b) == -1) vertexMap[a].push(b);
          if (vertexMap[b].indexOf(a) == -1) vertexMap[b].push(a);
        }
    
        // Find cycles
        const frontierNodes = Object.keys(vertexMap).map((v) => Number(v));
        const exploredNodes = {};
        const vertexIdToSurfaceId = {};
    
        while (frontierNodes.length > 0) {
          const node = frontierNodes.pop();
          if (exploredNodes[node]) continue;
    
          // Get all neighbors recursively
          const surfaceVertices = getNeighborsNonRecursive(node);
          // Mark them as explored
          for (let v of surfaceVertices) {
            exploredNodes[v] = true;
            vertexIdToSurfaceId[v] = this.surfaceId;
          }
    
          this.surfaceId += 1;
        }
        function getNeighbors(node, explored) {
          const neighbors = vertexMap[node];
          let result = [node];
          explored[node] = true;
    
          for (let n of neighbors) {
            if (explored[n]) continue;
            explored[n] = true;
            const newNeighbors = getNeighbors(n, explored);
            result = result.concat(newNeighbors);
          }
    
          return result;
        }
    
        function getNeighborsNonRecursive(node) {
          const frontier = [node];
          const explored = {};
          const result = [];
    
          while (frontier.length > 0) {
            const currentNode = frontier.pop();
            if (explored[currentNode]) continue;
            const neighbors = vertexMap[currentNode];
            result.push(currentNode);
    
            explored[currentNode] = true;
    
            for (let n of neighbors) {
              if (!explored[n]) {
                frontier.push(n);
              }
            }
          }
    
          return result;
        }
    
        return vertexIdToSurfaceId;
      }
    }

    function getSurfaceIdMaterial() {
      return new THREE.ShaderMaterial({
        uniforms: {
          maxSurfaceId: { value: 1 },
        },
        vertexShader: getVertexShader(),
        fragmentShader: getFragmentShader(),
        vertexColors: true,
      });
    }
    
    function getVertexShader() {
      return `
      varying vec2 v_uv;
      varying vec4 vColor;
    
      void main() {
         v_uv = uv;
         vColor = vec4(color.r, color.g, color.b, 1.0);
    
         gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
      `;
    }
    
    function getFragmentShader() {
      return `
      varying vec2 v_uv;
      varying vec4 vColor;
      uniform float maxSurfaceId;
    
      void main() {
        // Normalize the surfaceId when writing to texture
        // Surface ID needs rounding as precision can be lost in perspective correct interpolation 
        // - see https://github.com/OmarShehata/webgl-outlines/issues/9 for other solutions eg. flat interpolation.
        float surfaceId = round(vColor.r) / maxSurfaceId;
        gl_FragColor = vec4(surfaceId, 0.0, 0.0, 1.0);
      }
      `;
}

// Follows the structure of
// 		https://github.com/mrdoob/three.js/blob/master/examples/jsm/postprocessing/OutlinePass.js
class CustomOutlinePass extends Pass {
    constructor(resolution, scene, camera) {
      super();
  
      this.renderScene = scene;
      this.renderCamera = camera;
      this.resolution = new THREE.Vector2(resolution.x, resolution.y);
  
      this.fsQuad = new FullScreenQuad(null);
      this.fsQuad.material = this.createOutlinePostProcessMaterial();
  
      // Create a buffer to store the normals of the scene onto
      // or store the "surface IDs"
      const surfaceBuffer = new THREE.WebGLRenderTarget(
        this.resolution.x,
        this.resolution.y
      );
      surfaceBuffer.texture.format = THREE.RGBAFormat;
      surfaceBuffer.texture.type = THREE.HalfFloatType;
      surfaceBuffer.texture.minFilter = THREE.NearestFilter;
      surfaceBuffer.texture.magFilter = THREE.NearestFilter;
      surfaceBuffer.texture.generateMipmaps = false;
      surfaceBuffer.stencilBuffer = false;
      this.surfaceBuffer = surfaceBuffer;
  
      this.normalOverrideMaterial = new THREE.MeshNormalMaterial();
      this.surfaceIdOverrideMaterial = getSurfaceIdMaterial();
    }
  
    dispose() {
      this.surfaceBuffer.dispose();
      this.fsQuad.dispose();
    }
  
    updateMaxSurfaceId(maxSurfaceId) {
      this.surfaceIdOverrideMaterial.uniforms.maxSurfaceId.value = maxSurfaceId;
    }
  
    setSize(width, height) {
      this.surfaceBuffer.setSize(width, height);
      this.resolution.set(width, height);
  
      this.fsQuad.material.uniforms.screenSize.value.set(
        this.resolution.x,
        this.resolution.y,
        1 / this.resolution.x,
        1 / this.resolution.y
      );
    }
  
    render(renderer, writeBuffer, readBuffer) {
      // Turn off writing to the depth buffer
      // because we need to read from it in the subsequent passes.
      const depthBufferValue = writeBuffer.depthBuffer;
      writeBuffer.depthBuffer = false;
  
      // 1. Re-render the scene to capture all suface IDs in a texture.
      renderer.setRenderTarget(this.surfaceBuffer);
      const overrideMaterialValue = this.renderScene.overrideMaterial;
  
      this.renderScene.overrideMaterial = this.surfaceIdOverrideMaterial;
      renderer.render(this.renderScene, this.renderCamera);
      this.renderScene.overrideMaterial = overrideMaterialValue;
  
      this.fsQuad.material.uniforms["depthBuffer"].value =
        readBuffer.depthTexture;
      this.fsQuad.material.uniforms["surfaceBuffer"].value =
        this.surfaceBuffer.texture;
      this.fsQuad.material.uniforms["sceneColorBuffer"].value =
        readBuffer.texture;
  
      // 2. Draw the outlines using the depth texture and normal texture
      // and combine it with the scene color
      if (this.renderToScreen) {
        // If this is the last effect, then renderToScreen is true.
        // So we should render to the screen by setting target null
        // Otherwise, just render into the writeBuffer that the next effect will use as its read buffer.
        renderer.setRenderTarget(null);
        this.fsQuad.render(renderer);
      } else {
        renderer.setRenderTarget(writeBuffer);
        this.fsQuad.render(renderer);
      }
  
      // Reset the depthBuffer value so we continue writing to it in the next render.
      writeBuffer.depthBuffer = depthBufferValue;
    }
  
    get vertexShader() {
      return `
              varying vec2 vUv;
              void main() {
                  vUv = uv;
                  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
              }
              `;
    }
    get fragmentShader() {
      return `
              #include <packing>
              // The above include imports "perspectiveDepthToViewZ"
              // and other GLSL functions from ThreeJS we need for reading depth.
              uniform sampler2D sceneColorBuffer;
              uniform sampler2D depthBuffer;
              uniform sampler2D surfaceBuffer;
              uniform float cameraNear;
              uniform float cameraFar;
              uniform vec4 screenSize;
              uniform vec3 outlineColor;
              uniform vec2 multiplierParameters;
  
              varying vec2 vUv;
  
              // Helper functions for reading from depth buffer.
              float readDepth (sampler2D depthSampler, vec2 coord) {
                  float fragCoordZ = texture2D(depthSampler, coord).x;
                  float viewZ = perspectiveDepthToViewZ( fragCoordZ, cameraNear, cameraFar );
                  return viewZToOrthographicDepth( viewZ, cameraNear, cameraFar );
              }
              float getLinearDepth(vec3 pos) {
                  return -(viewMatrix * vec4(pos, 1.0)).z;
              }
  
              float getLinearScreenDepth(sampler2D map) {
                      vec2 uv = gl_FragCoord.xy * screenSize.zw;
                      return readDepth(map,uv);
              }
              // Helper functions for reading normals and depth of neighboring pixels.
              float getPixelDepth(int x, int y) {
                  // screenSize.zw is pixel size 
                  // vUv is current position
                  return readDepth(depthBuffer, vUv + screenSize.zw * vec2(x, y));
              }
              // "surface value" is either the normal or the "surfaceID"
              vec3 getSurfaceValue(int x, int y) {
                  vec3 val = texture2D(surfaceBuffer, vUv + screenSize.zw * vec2(x, y)).rgb;
                  return val;
              }
  
              float saturateValue(float num) {
                  return clamp(num, 0.0, 1.0);
              }
  
              float getSufaceIdDiff(vec3 surfaceValue) {
                  float surfaceIdDiff = 0.0;
                  surfaceIdDiff += distance(surfaceValue, getSurfaceValue(1, 0));
                  surfaceIdDiff += distance(surfaceValue, getSurfaceValue(0, 1));
                  surfaceIdDiff += distance(surfaceValue, getSurfaceValue(0, 1));
                  surfaceIdDiff += distance(surfaceValue, getSurfaceValue(0, -1));
  
                  surfaceIdDiff += distance(surfaceValue, getSurfaceValue(1, 1));
                  surfaceIdDiff += distance(surfaceValue, getSurfaceValue(1, -1));
                  surfaceIdDiff += distance(surfaceValue, getSurfaceValue(-1, 1));
                  surfaceIdDiff += distance(surfaceValue, getSurfaceValue(-1, -1));
                  return surfaceIdDiff;
              }
  
              void main() {
                  vec4 sceneColor = texture2D(sceneColorBuffer, vUv);
                  float depth = getPixelDepth(0, 0);
                  vec3 surfaceValue = getSurfaceValue(0, 0);
  
                  // Get the difference between depth of neighboring pixels and current.
                  float depthDiff = 0.0;
                  depthDiff += abs(depth - getPixelDepth(1, 0));
                  depthDiff += abs(depth - getPixelDepth(-1, 0));
                  depthDiff += abs(depth - getPixelDepth(0, 1));
                  depthDiff += abs(depth - getPixelDepth(0, -1));
  
                  // Get the difference between surface values of neighboring pixels
                  // and current
                  float surfaceValueDiff = getSufaceIdDiff(surfaceValue);
                  
                  // Apply multiplier & bias to each 
                  float depthBias = multiplierParameters.x;
                  float depthMultiplier = multiplierParameters.y;
  
                  depthDiff = depthDiff * depthMultiplier;
                  depthDiff = saturateValue(depthDiff);
                  depthDiff = pow(depthDiff, depthBias);
  
                  if (surfaceValueDiff != 0.0) surfaceValueDiff = 1.0;
  
                  float outline = saturateValue(surfaceValueDiff + depthDiff);
              
                  // Combine outline with scene color.
                  vec4 outlineColor = vec4(outlineColor, 1.0);
                  gl_FragColor = vec4(mix(sceneColor, outlineColor, outline));
              }
              `;
    }
  
    createOutlinePostProcessMaterial() {
      return new THREE.ShaderMaterial({
        uniforms: {
          sceneColorBuffer: {},
          depthBuffer: {},
          surfaceBuffer: {},
          outlineColor: { value: new THREE.Color(0xffffff) },
          //4 scalar values packed in one uniform:
          //  depth multiplier, depth bias
          multiplierParameters: {
            value: new THREE.Vector2(0.9, 20),
          },
          cameraNear: { value: this.renderCamera.near },
          cameraFar: { value: this.renderCamera.far },
          screenSize: {
            value: new THREE.Vector4(
              this.resolution.x,
              this.resolution.y,
              1 / this.resolution.x,
              1 / this.resolution.y
            ),
          },
        },
        vertexShader: this.vertexShader,
        fragmentShader: this.fragmentShader,
      });
    }
  }

  customElements.define('selected-option', class extends HTMLElement {});
  customElements.define('clever-options', class extends HTMLElement {});
  customElements.define('clever-option', class extends HTMLElement {});
  
  class CleverSelect extends HTMLElement {
      constructor() {
          super();
      }
      connectedCallback() {
          const that = this;
          //Wrap options in custom container
          this._wrapOptions();
          
          //create value holding input
          this._createValueHolder();
  
          //Get all options
          this.options = this.querySelectorAll('clever-option')
  
          //Create selected option display
          this._createSelectedOptionDisplay()
          
          //Set event listener for toggling the Select
          this.querySelector('selected-option').addEventListener('click',(e) => {
              that.toggleOpenState();
          })
          this.options.forEach(option => {
              //Set initial selected option
              if(option.hasAttribute('selected')){
                  that._setSelectedOption(option, false)
              }
              //Add event listeners to all options
              option.addEventListener('click',(e)=>{
                  if(!option.hasAttribute('disabled')){
                      e.preventDefault()
                      that._setSelectedOption(option)
                      that.close();
                  }
              })
          })
          
          //Set event listener to close when focus out
          document.body.addEventListener('click',(e) => {
              if(that.hasAttribute('open') && !that.contains(e.target)){
                  that.close()
              }
          })
      }
      attributeChangedCallback(name, oldValue, newValue) {
        console.log('Custom square element attributes changed.');
      }
      toggleOpenState(){
          if(this.hasAttribute('open')){
              this.removeAttribute('open')
          }
          else{
              this.setAttribute('open','')
          }
      }
      close(){
          this.removeAttribute('open')
      }
  
      //this functions should only be used by the element itself
      _setSelectedOption(option, events = true){
          this.value = option.getAttribute('value')
          this.options.forEach(option => {
              option.removeAttribute('selected')
          })
          option.setAttribute('selected', true)
          this.setAttribute('value',this.value)
          this.input.setAttribute('value',this.value)
          this.selectedOption.innerHTML = option.innerHTML;
          for (let index = 0; index < option.attributes.length; index++) {
            const element = option.attributes.item(index);
            this.selectedOption.setAttribute(element.name, element.value); 
          }
          if(events){
              this.input.dispatchEvent(new Event('change', {bubbles: true, cancelable: false, composed: true}))
              this.input.dispatchEvent(new Event('input', {bubbles: true, cancelable: false, composed: true}))
          }
      }
      _wrapOptions(){
          let wrappedContent = document.createElement('clever-options');
          let options = this.querySelectorAll('option')
          options.forEach(o => {
              let no = document.createElement('clever-option')
              no.value = o.value;
              no.setAttribute('value', o.value)
              if(o.hasAttribute('selected')){
                  no.selected = o.selected;
                  no.setAttribute('selected', o.selected)     
              }
              if(o.hasAttribute('disabled')){
                  no.disabled = o.disabled;
                  no.setAttribute('disabled', o.disabled)     
              }
              
              // custom made adjustment. Maybe making it adjustable
              for (let index = 0; index < o.attributes.length; index++) {
                const element = o.attributes.item(index);
                no.setAttribute(element.name, element.value); 
              }
  
              no.innerHTML = o.innerHTML;
              wrappedContent.appendChild(no)
          })
          this.innerHTML = wrappedContent.outerHTML;
      }
      _createSelectedOptionDisplay(){
          this.selectedOption = document.createElement('selected-option');
          this.selectedOption.innerHTML = String(this.getAttribute('placeholder'))
          this.appendChild(this.selectedOption)
      }
      _createValueHolder(){
          this.input = document.createElement('input')
          this.input.type = 'text'
          this.input.setAttribute('hidden','')
          this.input.setAttribute('name', this.getAttribute('name'))
          this.removeAttribute('name')
          this.appendChild(this.input)
      }
  }
  customElements.define('clever-select', CleverSelect);

export {Measurements, AnimatedAction, Time, MousePickPass, SnapPoint, Tools, XRSession, LivomModule, LivomModulePreset, CanvasTools, ShopifyTools, CleverSelect}